import { Injectable, Type } from '@angular/core';
import {
    OverrideDescriptor,
    ShBaseGenericReadonlyFieldComponent,
    ShProfileConfigService
} from '@stylehaven/components';
import { Observable, of } from 'rxjs';
import { DottedKey } from '../../record/entities/metadata-field.entity';
import { DocumentPublicityReadonlyFieldComponent } from '../components/readonly/document-publicity-readonly-field/document-publicity-readonly-field.component';
import { DossierPublicityReadonlyFieldComponent } from '../components/readonly/dossier-publicity-readonly-field/dossier-publicity-readonly-field.component';
import { RecordReuseReadonlyFieldComponent } from '../components/readonly/record-reuse-readonly-field/record-reuse-readonly-field.component';
import { RetentionPeriodReadonlyFieldComponent } from '../components/readonly/retention-period-readonly-field/retention-period-readonly-field.component';
import { SeriesProcessReadonlyFieldComponent } from '../components/readonly/series-process-readonly-field/series-process-readonly-field.component';
import { SeriesServiceReadonlyFieldComponent } from '../components/readonly/series-service-readonly-field/series-service-readonly-field.component';
import { DigihavenComponentType } from '../entities/digihaven-component-type.entity';

@Injectable({ providedIn: 'root' })
export class ProfileConfigService extends ShProfileConfigService {
    public overrideReadonlyMapping: Record<string, Type<ShBaseGenericReadonlyFieldComponent>> = {
        [DigihavenComponentType.RetentionPeriod]: RetentionPeriodReadonlyFieldComponent,
        [DigihavenComponentType.SeriesProcess]: SeriesProcessReadonlyFieldComponent,
        [DigihavenComponentType.SeriesServiceIpdc]: SeriesServiceReadonlyFieldComponent,
        [DigihavenComponentType.RecordReuse]: RecordReuseReadonlyFieldComponent,
        [DigihavenComponentType.DossierPublicity]: DossierPublicityReadonlyFieldComponent,
        [DigihavenComponentType.DocumentPublicity]: DocumentPublicityReadonlyFieldComponent
    };

    protected getReadonlyOverridesConfig(): Observable<Record<string, OverrideDescriptor>> {
        const overrides: Record<string, OverrideDescriptor> = {
            [DottedKey.SeriesRetentionPeriodAdministrative]: { type: DigihavenComponentType.RetentionPeriod },
            [DottedKey.SeriesRetentionPeriodLegal]: { type: DigihavenComponentType.RetentionPeriod },
            [DottedKey.SeriesProcess]: { type: DigihavenComponentType.SeriesProcess },
            [DottedKey.SeriesServiceIpdc]: { type: DigihavenComponentType.SeriesServiceIpdc },
            [DottedKey.RecordReuse]: { type: DigihavenComponentType.RecordReuse },
            [DottedKey.DossierPublicity]: { type: DigihavenComponentType.DossierPublicity },
            [DottedKey.DocumentPublicity]: { type: DigihavenComponentType.DocumentPublicity }
        };
        return of(overrides);
    }
}
